"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BIEventsService = void 0;
var BIEventsMessagingService_1 = require("../bi-events-messaging/BIEventsMessagingService");
var config_default_1 = require("./config.default");
var indexedDBInitialization_1 = require("../indexeddb/indexedDBInitialization");
var consts_1 = require("../consts");
var formatEnv_1 = require("../tools/formatEnv");
var biEnums_1 = require("./biEnums");
/**
 * Represents an instance of the BI events logger.
 */
var BIEventsService = /** @class */ (function () {
    /**
     * Starting the BI events sending interval.
     * @constructor
     * @param config initial config you would like the application to represent.
     */
    function BIEventsService(config) {
        var _this = this;
        this.setConfig(config);
        var messagingService = new BIEventsMessagingService_1.BIEventsMessagingService();
        // Activate the interval to send BI events
        setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, messagingService.sendingInterval(this.config)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }, this.config.sendingInterval);
    }
    /**
     * Once you already instantiated {@link BIEventsService} instance, you may override its {@link IBIConfig} config using this method.
     * @param {IBIConfig} config - config to be overridden. May contain only partial data that you want to override.
     */
    BIEventsService.prototype.setConfig = function (config) {
        if (!config.url) {
            console.error("Url field must be passed");
            return;
        }
        if (!config.env) {
            console.error("Env field must be passed");
            return;
        }
        if (!consts_1.acceptedEnvs.includes((0, formatEnv_1.formatEnv)(config.env))) {
            console.error("Env field must be from the list:", consts_1.acceptedEnvs);
            return;
        }
        if (!config.maxMessagesBulk)
            (config.maxMessagesBulk = config_default_1.defaultConfig.maxMessagesBulk);
        if (!config.sendingInterval)
            (config.sendingInterval = config_default_1.defaultConfig.sendingInterval);
        this.config = config;
    };
    /**
     * Add a BI event.
     * BIEventsService will automatically send this BI event according to sendingInterval configuration.
     * @param biEvent - the BI event to add.
     */
    BIEventsService.prototype.addBIEvent = function (biEvent) {
        return __awaiter(this, void 0, void 0, function () {
            var isValidType, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        isValidType = Object.values(biEnums_1.BIEventType).includes(biEvent.type);
                        if (!isValidType)
                            throw new Error("Invalid BI event type: ".concat(biEvent.type));
                        return [4 /*yield*/, indexedDBInitialization_1.DB.addBIEvent(biEvent)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return BIEventsService;
}());
exports.BIEventsService = BIEventsService;
//# sourceMappingURL=BIEventsService.js.map